import styled from '@emotion/styled'

import { PlugIcon, CompliantIcon, FocusIcon } from '@segment/matcha/components/Icons/Brandbook'
import Tabs, { useTabs } from '@segment/matcha/components/Tabs'

import CarouselCardBase, * as CarouselCard from '@segment/matcha/recipes/CarouselCard'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionTabbedBase, * as SectionTabbed from '@segment/matcha/recipes/SectionTabbed'

import CollectDataTabsOneImage from './CollectDataTabsOneImage'
import CollectDataTabsTwoImage from './CollectDataTabsTwoImage'
import CollectDataTabsThreeImage from './CollectDataTabsThreeImage'

const copy = {
  heading: `Collect data, the right way`,
  description: `Collect user events from any app with our simple analytics API.`,
}

const tabs = [
  {
    key: `data-from-any-platform`,
    title: `Collect data from your apps`,
    description: `Collect user event data from all web, mobile, and warehouse sources.`,
    icon: <PlugIcon />,
    image: <CollectDataTabsOneImage />,
  },
  {
    key: `data-across-teams`,
    title: `Align data across teams`,
    description: `Align your marketing, data, and engineering team with a single shared data dictionary.`,
    icon: <FocusIcon />,
    image: <CollectDataTabsTwoImage />,
  },
  {
    key: `respect-end-user-privacy`,
    title: `Respect end-user privacy`,
    description: `Ensure all of your destinations are respecting your privacy assessment in real-time. Accelerate compliance with privacy regulations like GDPR, CCPA, and more.`,
    icon: <CompliantIcon />,
    image: <CollectDataTabsThreeImage />,
  },
]

export const CollectData = () => {
  const { activeTabKey, getTabsProps, getTabsMotionProps } = useTabs(tabs[0].key)
  return (
    <SectionComponent variant="centered">
      <Section.Copy>
        <CopyTextBase centered={true}>
          <CopyText.Heading variant="h2" tag="h2">
            {copy.heading}
          </CopyText.Heading>
          <CopyText.Description>{copy.description}</CopyText.Description>
        </CopyTextBase>
      </Section.Copy>
      <Section.Contents>
        <SectionTabbedBase>
          <SectionTabbed.Copy>
            <Tabs {...getTabsProps()} mode="vertical" variant="filled">
              {tabs.map((tab) => (
                <CarouselCardBase value={tab.key} key={tab.key} active={activeTabKey === tab.key}>
                  <CarouselCard.Container alignment="left" headerPosition="top">
                    <CarouselCard.Header>{tab.icon}</CarouselCard.Header>
                    <CarouselCard.Body>
                      <CarouselCard.Title>{tab.title}</CarouselCard.Title>
                      <CarouselCard.Text>{tab.description}</CarouselCard.Text>
                    </CarouselCard.Body>
                  </CarouselCard.Container>
                </CarouselCardBase>
              ))}
            </Tabs>
          </SectionTabbed.Copy>
          {tabs.map((tab) => (
            <SectionTabbed.Media key={tab.key} {...getTabsMotionProps(tab.key)}>
              <SectionTabbed.Picture>{tab.image}</SectionTabbed.Picture>
            </SectionTabbed.Media>
          ))}
        </SectionTabbedBase>
      </Section.Contents>
    </SectionComponent>
  )
}

const SectionComponent = styled(SectionBase)`
  overflow: hidden;
`
